module.exports = __webpack_public_path__ + "static/media/9.598ab422.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/9.png
// module id = 718
// module chunks = 0